import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { PatientCard } from '../components/PatientCard';
import { PatientHistoryItem } from '../components/PatientHistoryItem';
import { setPatientFromAxios } from '../redux/reducers/patient';
import Axios from '../utils/axios';

function PatientDetail() {
	let { id } = useParams();
	const patient = useSelector((state) => state.patient);

	const dispatch = useDispatch();

	const [data, setData] = useState('');

	useEffect(() => {
		async function fetchData() {
			let user_data;

			if (id === undefined) {
				const res = await Axios.get('/patient/next');
				user_data = res.data.patient;
			} else {
				const res = await Axios.get(`/patient/${id}`);
				user_data = res.data;
			}
			dispatch(setPatientFromAxios(user_data));
			const pres_data = await Axios.get(`/patient/${user_data.id.$oid}/all_recipes_prescription`);
			setData(pres_data.data);
		}
		fetchData();
	}, [id, dispatch]);
	return (
		<div
			className="grid w-11/12 h-full px-2 m-auto my-6 divide-y-2 divide-blue-100 rounded-lg shadow-2xl bg-cyan-600 grid-row-5"
			id="detail"
		>
			<div className="container p-3 mx-auto" id="pc_card">
				<PatientCard patient={patient} />
			</div>
			<div className="row-span-4 p-3">
				<label className="text-white ">تاریخچه نسخه‌ها:</label>
				{data &&
					data.items.map((item, index) => (
						<PatientHistoryItem
							key={index}
							id={item.id}
							created={item.created}
							patientId={item.patientId}
							type={item.type}
						/>
					))}
			</div>
		</div>
	);
}

export default PatientDetail;
